import { combineReducers } from 'redux';

import activityReducer from './ducks/activity';
import failureAnalysisReducer from './ducks/failure-analysis';
import filtersReducer from './ducks/filters';
import general from './ducks/general';
import ownersReducer from './ducks/filters/reducers/owners';
import rootCausesReducer from './ducks/root-causes';
import rdcReducer from './ducks/rdc';
import vdcReducer from './ducks/vdc';
import filterBarReducer from './ducks/filterBar';

const reducers = {
  activity: activityReducer,
  failureAnalysis: failureAnalysisReducer,
  filters: filtersReducer,
  generalReducer: general,
  owners: ownersReducer,
  rootCauses: rootCausesReducer,
  rdc: rdcReducer,
  vdc: vdcReducer,
  filterBar: filterBarReducer,
};

export default combineReducers(reducers);
